import { Component, OnInit, Input, HostBinding, SimpleChanges, ChangeDetectorRef, Output, EventEmitter, ElementRef, Renderer2 } from '@angular/core';
import * as _ from 'lodash';
import { ProductAvailability } from 'src/app/models/verylys/product.model';
import { SafeResourceUrl } from '@angular/platform-browser';
import { PopulateFileMedia } from 'src/app/models/verylys/verylys';

@Component({
    selector: 'product-cover',
    templateUrl: './product-cover.component.html',
    styleUrls: ['./product-cover.component.scss'],
})
export class ProductCoverComponent implements OnInit {
    @Input() background: string | SafeResourceUrl | PopulateFileMedia = null;
    @Input() logo: string | SafeResourceUrl | PopulateFileMedia = null;
    @Input() ribbon: null | ProductAvailability = null;
    @Input() enableSkeleton: boolean = true;
    @Input() logoPosition: "middle" | "top" | "bottom" = "middle";
    @Input() hovering: boolean;
    @Input() mini: boolean;

    @HostBinding('class') class: string;

    protected mounted = true;
    protected loaded = false;
    protected alreadyLoaded: boolean = false;
    protected ribbonStatus = null;
    protected logoPositionCss: string;

    constructor(private elementRef: ElementRef, private renderer2: Renderer2) {

    }

    ngOnInit(): void {
        this.logoPositionCss = this.getLogoPosition();
        this.ribbonStatus = this.ribbonColor();
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('ribbon' in changes) {
            this.ribbon = changes['ribbon'].currentValue;
            this.ribbonStatus = this.ribbonColor();
        }

        if ('logoPosition' in changes) {
            this.logoPosition = changes['logoPosition'].currentValue;
            this.logoPositionCss = this.getLogoPosition();
        }

        if ('hovering' in changes) {
            this.hovering = changes['hovering'].currentValue;
            if (this.hovering) {
                this.renderer2.addClass(this.elementRef.nativeElement, "hover-translate");
            }
        }

        if ('mini' in changes) {
            this.mini = changes['mini'].currentValue;
            this.logoPositionCss = this.getLogoPosition();
        }
    }

    private getLogoPosition(): string {
        switch (this.logoPosition) {
            case 'bottom':
                return 'bottom-2.5 -translate-x-1/2';
            case 'middle':
                return this.mini ? 'top-1/2 -translate-x-1/2 -translate-y-1/2' : 'top-1/2 -translate-x-1/2 -translate-y-1/2';
            case 'top':
                return this.mini ? 'top-2.5 -translate-x-1/2' : 'top-5 -translate-x-1/2';
        }
    }

    protected ribbonColor() {
        switch (this.ribbon) {
            case ProductAvailability.COMINGSOON:
                return "light";
            case ProductAvailability.NEW:
                return "success";
            default:
                return "success";
        }
    }

    protected ribbonTonLocalize() {
        switch (this.ribbon) {
            case ProductAvailability.COMINGSOON:
                return $localize`:@@product_availability.comingsoon:Coming Soon`;
            case ProductAvailability.NEW:
                return $localize`:@@product_availability.new:New`;
            case ProductAvailability.PREORDER:
                return $localize`:@@product_availability.preorder:Preorder`;
            default:
                return null;
        }
    }
}